import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { ChakraProvider, defaultSystem, Container } from '@chakra-ui/react';
import { RequiredAuth } from './SecureRoute';
import CustomLoginCallback from './CustomLoginCallback';
import config from './config';
import Navbar from './Navbar';
import UserPasswordReset from './UserPasswordReset';
import UserIdentityVerification from './UserIdentityVerification';
import Home from './Home';
import Error from './Error';
import ManagerAddExternalEmail from './ManagerAddExternalEmail';
import ManagerResetPassword from './ManagerResetPassword';
import ManagerIdentityVerification from './ManagerIdentityVerification';
import Alexa4BusinessIdentityVerification from './Alexa4BusinessIdentityVerification';

const oktaAuth = new OktaAuth(config.oidc);

const App = () => {
  const navigate = useNavigate();

  const triggerLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };

  const customAuthHandler = async () => {
    // Trigger login for both app initialization and token autoRenew
    await triggerLogin();
  };

  return (
    <ChakraProvider value={defaultSystem}>
      <Security
        oktaAuth={oktaAuth}
        onAuthRequired={customAuthHandler}
        restoreOriginalUri={restoreOriginalUri}
      >
        <Navbar />
        <Container maxW="700px" mt="7em">
          <Routes>
            {/* Public routes - no authentication required */}
            <Route path='/login/callback' element={<CustomLoginCallback />} />
            <Route path='/Error' element={<Error />} />
            
            {/* Protected routes - authentication required */}
            <Route path='/' element={<RequiredAuth />}>
              <Route path='' element={<Home />} />
              <Route path='/PasswordReset' element={<UserPasswordReset />} />
              <Route path='/IdentityValidation' element={<UserIdentityVerification />} />
              <Route path='/Manager-AddExternalEmail' element={<ManagerAddExternalEmail />} />
              <Route path='/Manager-PasswordReset' element={<ManagerResetPassword />} />
              <Route path='/Manager-IdentityValidation' element={<ManagerIdentityVerification />} />
              <Route path='/Alexa-IdentityValidation' element={<Alexa4BusinessIdentityVerification />} />
            </Route>
          </Routes>
        </Container>
      </Security>
    </ChakraProvider>
  );
};

export default App;
